import { Box, Radio, useTheme } from "@mui/material";
import samanLogo from "../../../../../../media/images/icons/saman-logo.svg";

interface Props {
  checked: boolean;
  handleCheck: (id: number) => void;
  id: number;
}

export default function GatewayItem(props: Props) {
  const theme = useTheme();

  const { checked, handleCheck, id } = props;

  return (
    <Box
      onClick={() => handleCheck(id)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <Box
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary[50],
          borderRadius: "8px",
          paddingX: "3px",
          paddingY: "0px",
        }}
      >
        <Radio checked={checked} size="small" />
        <img width={70} src={samanLogo} alt="" />
      </Box>
    </Box>
  );
}
